import { useFormContext } from 'react-hook-form';
import { Box, Chip, Typography } from '@mui/material';
import _ from 'lodash';
import RHFMultipleSelectField from '../../../common/hook-form/RHFMultipleSelectField';
import { delivered, deliveryFailed, rto, transit, placed, cancelled, lost } from '../../../helpers/UtilityHelper';
import { FONT, SIZE, WEIGHT } from '../../../styles/foundation/typography';
import { SUBTLE } from '../../../styles/foundation/colors';

/**
 * "Order Status" multi-select (form field `status`, value: array). `active` is the shipment-list
 * tab: each tab offers only its own statuses; any other value (All tab, Reverse) offers them all.
 */
export function OrderStatusWiseFilter({ active }) {
  let options = [...deliveryFailed, ...rto, ...transit, ...delivered, ...placed, ...cancelled, ...lost]
  if (active === 1) options = deliveryFailed
  else if (active === 2) options = placed
  else if (active === 3) options = transit
  else if (active === 4) options = delivered
  else if (active === 5) options = rto

  options = options.map((op) => ({ label: _.startCase(op), value: op }))

  return (
    <RHFMultipleSelectField name="status" width="100%" variant="outlined" label="Order Status" options={_.orderBy(options, 'label')} search compact />
  )
}

/**
 * Chips for the APPLIED statuses; the × on one removes it and re-applies the filter.
 * Render inside the page's FormProvider; `onApply` is the page's filter submit handler.
 */
export function OrderStatusChips({ applied, onApply }) {
  const { setValue, handleSubmit } = useFormContext();
  const list = toStatusList(applied);
  if (!list.length) return null;
  const remove = (status) => {
    setValue('status', list.filter((s) => s !== status));
    handleSubmit(onApply)();
  };
  return (
    <Box sx={{ display: 'flex', gap: 1, flexWrap: 'wrap', alignItems: 'center', mt: 1.5 }}>
      <Typography sx={{ fontFamily: FONT, fontSize: SIZE['2xs'], fontWeight: WEIGHT.semibold, color: SUBTLE }}>
        Order Status:
      </Typography>
      {list.map((s) => <Chip key={s} size="small" label={_.startCase(s)} onDelete={() => remove(s)} />)}
    </Box>
  );
}

export const toStatusList = (status) => (Array.isArray(status) ? status : [status]).filter(Boolean);

/** andfilter clause for the selected statuses (array, or a single value), or null when none is selected. */
export const orderStatusClause = (status) => {
  const list = toStatusList(status);
  return list.length ? { field: 'orderStatus', operator: 'in', value: list } : null;
};
